<template>
  <div class="auth-layout-form">
    <b-form @submit.prevent="onSubmit">
      <b-form-group>
        <p class="mb-3 text-center">
          کد 5 رقمی پیامک شده به شماره زیر را وارد کنید
        </p>
        <p class="text-center">
          <span class="ml-2">{{ form.phone.value }}</span>
          <b-icon icon="phone-fill" scale="2" variant="warning"></b-icon>
        </p>
      </b-form-group>
      <b-form-group>
        <b-form-input
          @update="verifyCodeChangeHandler"
          :state="this.validVerifyCode"
          type="text"
          v-model="form.verifyCode.value"
          placeholder="کد تایید"
        />
        <b-form-invalid-feedback
          class="text-right"
          :state="this.validVerifyCode"
        >
          {{ form.verifyCode.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <p>
        <span v-if="counter > 0">
          امکان ارسال مجدد کد بعد از {{ counter }} ثانیه
        </span>
        <span
          v-else
          class="text-primary"
          variant="link"
          style="cursor: pointer"
          @click="resendVerifyCode"
        >
          ارسال مجدد کد تایید
        </span>
      </p>
      <LoadingBtn
        :loading="loader"
        block
        :disabled="disabled || loader"
        type="submit"
        variant="primary"
      >
        ارسال کد تایید
      </LoadingBtn>
      <error-messages
        :show="showMessage"
        :dismissible="true"
        @dismissed="dismissedError"
        :messages="alertMessage"
      />
    </b-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { phoneVerificationToken, phoneVerification } from "@/services/auth";
import {
  SHOW_MESSAGE,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  HIDE_MESSAGE
} from "@/store/mutation-types";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn";
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessages.vue";
export default {
  name: "ResendEmail",
  components: {
    LoadingBtn,
    ErrorMessages
  },
  props: {
    form: Object
  },
  data() {
    return {
      counter: 120,
      disabled: true,
      timerInterval: null,
      validVerifyCode: null
    };
  },
  computed: {
    ...mapState("auth", ["showMessage", "alertMessage", "loader"])
  },
  mounted() {
    this.timerInterval = setInterval(this.timer, 1000);
  },
  methods: {
    ...mapActions("auth", [
      SHOW_MESSAGE,
      HIDE_MESSAGE,
      ON_SHOW_LOADER,
      ON_HIDE_LOADER
    ]),
    dismissedError: function() {
      this[HIDE_MESSAGE]();
    },
    resendVerifyCode: async function() {
      this[ON_SHOW_LOADER]();
      const [error, data] = await phoneVerificationToken({
        phoneNumber: this.form.phone.value
      });
      if (error) {
        this[SHOW_MESSAGE](error);
      } else {
        if (data.apiStatus === 200) {
          this[ON_HIDE_LOADER]();
          this.counter = 120;
          this.form = { ...this.form, verifyCode: { value: "", error: "" } };
        } else {
          this[SHOW_MESSAGE](data.apiErrors);
        }
      }
    },
    verifyCodeChangeHandler: function(val) {
      if (val === "") {
        this.form.verifyCode.error = "کد تایید را وارد کنید.";
        this.validVerifyCode = false;
      } else {
        if (val.length !== 5) {
          this.form.verifyCode.error = "کد تایید 5 رقمی است.";
          this.validVerifyCode = false;
        } else {
          this.form.verifyCode.error = "";
          this.validVerifyCode = true;
        }
      }
    },
    onSubmit: async function() {
      this[ON_SHOW_LOADER]();
      const [error, data] = await phoneVerification({
        token: this.form.verifyCode.value
      });
      if (error) this[SHOW_MESSAGE](error);
      else {
        if (data.apiStatus === 200) {
          this[ON_HIDE_LOADER]();
          this.$router.push("/login");
        } else {
          this[SHOW_MESSAGE](data.apiErrors);
        }
      }
    },
    timer: function() {
      if (this.counter > 0) {
        this.counter--;
      }
    }
  },
  updated() {
    if (this.validVerifyCode) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  },
  destroyed() {
    clearInterval(this.timerInterval);
  }
};
</script>
